import { InfoCircleOutlined } from '@ant-design/icons';
import { ProfileNavItem } from '@app/constants/profileNavData';
import { ADMIN_BASE_BATH } from '@app/constants/variables';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as S from './DealRoomNav.styles';

const dealRoomNavData: ProfileNavItem[] = [
  {
    id: 1,
    name: 'dealRooms.form.dealRoomInfo',
    icon: <InfoCircleOutlined />,
    color: 'primary',
    href: 'deal-room-info',
  },
  {
    id: 2,
    name: 'dealRooms.form.dealRoomAttributes',
    icon: <InfoCircleOutlined />,
    color: 'primary',
    href: 'deal-room-attributes',
  },
  {
    id: 3,
    name: 'dealRooms.form.dealRoomFilesUploadedByUsers',
    icon: <InfoCircleOutlined />,
    color: 'primary',
    href: 'deal-room-external-files',
  },
  {
    id: 4,
    name: 'dealRooms.form.dealRoomChat',
    icon: <InfoCircleOutlined />,
    color: 'primary',
    href: 'deal-room-chat',
  },
];

export const DealRoomNav: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();

  const [navData, setNavData] = useState<ProfileNavItem[]>([]);

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (id) {
      setNavData(
        dealRoomNavData.map((item) => ({
          ...item,
          href: `${item.href}/${id}`,
        })),
      );
    } else {
      setNavData(dealRoomNavData.filter((item) => item.id === 1));
    }
  }, [id]);

  return (
    <S.Wrapper>
      {navData.map((item) => (
        <S.Btn
          key={item.id}
          icon={item.icon}
          type="text"
          color={item.color}
          onClick={() => navigate(item.href)}
          isActive={`${ADMIN_BASE_BATH}/deal-rooms/${item.href}` === location.pathname}
        >
          {`${t(item.name)}`}
        </S.Btn>
      ))}
    </S.Wrapper>
  );
};
